module.exports = __webpack_public_path__ + "static/Building-Sketches-Desktop-99bd3e2864e38c1d32a578943e805885.jpg";